import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormFile = _resolveComponent("FormFile");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        infoPayload: _ctx.infoPayload,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        cancelBtnTxt: "Cancel",
        actionBtnTxt: "Open",
        onOnPopupDone: _ctx.onPopupDone,
        isActionBtnEnabled: _ctx.filesToLoad.length > 0,
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createVNode(_component_FormFile, {
                ref: "formFile",
                multiple: true,
                onOnFilesLoaded: _ctx.onFilesLoaded,
                accept: _ctx.accept,
                id: "formFile-openmolecules-item"
            }, null, 8, ["onOnFilesLoaded", "accept"])
        ]),
        _: 1
    }, 8, ["infoPayload", "modelValue", "onOnPopupDone", "isActionBtnEnabled", "onOnUserArgChanged"]));
}
